import {
  Box,
  Table,
  Text,
  Tag,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";

import ServiceTimePerServiceLineGraph from "../../charts/daily/ServiceTimePerServiceLineGraph";

import { formatTime, formatNumber } from "../../../../store/helpers";

const OrganizationServiceTimePerServiceTable = ({
  branchId = null,
  data,
  reportIndex,
  branchIndex,
  numServices,
  branchName,
}) => {
  const { showEmptyDataSets } = useSelector((state) => state.defaultReducer);

  let branch = {};
  let chartTitle = "Entire Organization,";
  if (branchId) {
    chartTitle = `${branchName} Branch, `;
  }

  const branchTitle = branchId
    ? `${reportIndex}. ${
        branchIndex ? branchIndex + ". " : ""
      }${branchName} Branch`
    : "Entire Organization";
  return (
    <Box mt={10}>
      {branchId ? (
        <Box mb="20px">
          <h2>{branchTitle}</h2>
          <p>{numServices} services.</p>
        </Box>
      ) : (
        <Box mb="20px">
          <h2 size="xl">{reportIndex}. 1. Entire Organization</h2>
        </Box>
      )}
      {data.map((a, index) => {
        return (
          <Box key={index} className="reportContainer" mt="20px">
            <Box mb="10px">
              <h3>
                {reportIndex}. {branchIndex ? branchIndex + ". " : null}
                {index + 1}. {a.name}
              </h3>
              {branchId ? (
                <Tag.Root>
                  <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
                </Tag.Root>
              ) : null}
            </Box>
            {showEmptyDataSets ||
            (!showEmptyDataSets && Number(a.completed) > 0) ? (
              <Table.Root className="stripedTable" size="sm">
                <Table.Header>
                  <Table.Row>
                    <Table.ColumnHeader borderRight="1px solid #dadce0">
                      Total Completed Tickets
                    </Table.ColumnHeader>
                    <Table.ColumnHeader borderRight="1px solid #dadce0">Total Service Time</Table.ColumnHeader>
                    <Table.ColumnHeader>Avg /ticket.</Table.ColumnHeader>
                    <Table.ColumnHeader>Min.</Table.ColumnHeader>
                    <Table.ColumnHeader>Max</Table.ColumnHeader>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell borderRight="1px solid #dadce0">
                      <Text color={"var(--blue)"}>
                        {formatNumber(a.completed)}
                      </Text>
                    </Table.Cell>
                    <Table.Cell borderRight="1px solid #dadce0">
                      <Text color={"var(--blue)"}>
                        {formatTime(a.sessionInSeconds)}
                      </Text>
                    </Table.Cell>
                    <Table.Cell>
                      <Text>{formatTime(a.avg)}</Text>
                    </Table.Cell>
                    <Table.Cell>
                      <Text>{formatTime(a.min)}</Text>
                    </Table.Cell>
                    <Table.Cell borderRight="1px solid #dadce0">
                      <Text>{formatTime(a.max)}</Text>
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colSpan={9} p={0}>
                      <Box mt="20px" mb="20px">
                        <ServiceTimePerServiceLineGraph
                          title={`${a.name}: ${chartTitle} Hour by Hour Comparison`}
                          chart={a.hours}
                          chartHeight="200px"
                        />
                      </Box>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table.Root>
            ) : (
              <Text fontSize="sm">No data available for this report</Text>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default OrganizationServiceTimePerServiceTable;
